export default function authHeader(contentType = 'application/json') {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken) {
        // for Node.js Express back-end
        return {
            'x-access-token': user.accessToken,
            'Content-type': contentType,
            'X-Content-Type-Options': 'nosniff'
        };
    } else {
        return {
            'Content-type': contentType,
            'X-Content-Type-Options': 'nosniff'
        };
    }
}
